/* eslint-disable */
import React, { useState, useEffect, useContext } from "react";
import { Link, useParams } from "react-router-dom";
import CreatableSelect from "react-select/creatable";
import Select from "react-select";

import { useTranslation } from "react-i18next";

/*import url and gateway methods */
import { getData, postData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

import { ecosystemSlug } from "Config/Config";

import contactOptions from "data/Prod/ContactOptions.json";
import knowingOptions from "data/Prod/RelationOptions.json";

import { GlobalProvider } from "context/GlobalContext";

const AddNewContactModal = ({
  afterCloseModalHandler,
  setShowAlert,
  setAlertMessage,
  setMessageType,
}) => {
  const { t } = useTranslation();
  const params = useParams();

  const token = localStorage.getItem("token");

  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const { setreloadRequestList } = useContext(GlobalProvider);

  const [userInput, setUserInput] = useState("");
  const [userOptions, setuserOptions] = useState([]);
  const [userValue, setUserValue] = useState(null);
  const [userId, setUserId] = useState(null);
  const [userEmail, setUserEmail] = useState("");
  const [selectContactOptionValue, setSelectContactOptionValue] =
    useState(null);
  const [selectContactOption, setSelectContactOption] = useState("");
  const [selectKnowingOptionValue, setselectKnowingOptionValue] =
    useState(null);
  const [selectKnowingOption, setselectKnowingOption] = useState("");
  const [connectMessage, setConnectMessage] = useState("");

  const [isAdding, setIsAdding] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};

    if (!userValue) {
      newErrors.user = t("Please select a user or enter their email address.");
    }
    if (!selectContactOption) {
      newErrors.contactType = t("Please specify the type of contact.");
    }
    if (!selectKnowingOption) {
      newErrors.knowingType = t("Please select how you know this person.");
    }
    if (!connectMessage.trim()) {
      newErrors.connectMessage = t(
        "A personal message is required to connect."
      );
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  //function for get user input
  const userInputHandler = (val) => {
    setUserInput(val);
    setErrorMessage("");
  };

  //function for get user details
  const getUserList = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_USERLIST +
        `?token=${token}` +
        `&userstring=${userInput}`;

      const response = await getData(requestUrl);

      console.log(response);

      if (response.status) {
        if (response.data.length > 0) {
          setuserOptions(response.data);
        }
      }
    } catch (error) {
      setMessageType("error");
      setAlertMessage(error.message);
      setShowAlert(true);
    }
  };

  //function user Selection
  const userSelectionHandler = (val) => {
    setErrorMessage("");
    if (val) {
      setUserValue(val);
      val._id ? setUserId(val._id) : setUserId(null); // if new user or other than contact user email is added
      val.email ? setUserEmail(val.email) : setUserEmail(val.value); // if new user or other than contact, set value as email
    } else {
      resetHandler();
    }
  };

  //** Function for add/invite for contact
  const sendInviteHandler = async () => {
    if (!validateForm()) {
      return;
    }
    setIsAdding(true);

    try {
      let connectData = {
        useremail: userEmail.trim(),
        member: userId,
        reason: selectContactOption,
        source: selectKnowingOption,
        message: connectMessage,
      };

      console.log("MemberData---->", connectData);

      let requestUrl =
        url.API_BASE_URL + url.API_SEND_REQUEST_USER + `?token=${token}`;

      const response = await postData(requestUrl, connectData);

      setIsAdding(false);

      console.log("response---->", response);
      // console.log(response);

      if (response.status) {
        setMessageType("success");

        setreloadRequestList(true);

        //hide member modal
        let bootstrapModal = document.querySelector("#addContactModal");
        let modal = bootstrap.Modal.getInstance(bootstrapModal);
        modal.hide();

        //call member list api function
        resetHandler();
        afterCloseModalHandler();
      } else {
        setMessageType("error");
        setErrorMessage(response.message);
      }
      setAlertMessage(response.message);
    } catch (error) {
      setMessageType("error");
      setAlertMessage(error.message);
    }

    setShowAlert(true);
  };

  //** Function for reset
  const resetHandler = () => {
    setUserInput("");
    setUserId(null);
    setUserEmail("");
    setuserOptions([]);
    setUserValue(null);
    setSelectContactOptionValue(null);
    setSelectContactOption("");
    setselectKnowingOptionValue(null);
    setselectKnowingOption("");
    setConnectMessage("");
    setErrorMessage("");
    setErrors({});
  };

  useEffect(() => {
    if (userInput.length > 0) {
      getUserList();
    }
  }, [userInput]);

  const optionsToShow = userOptions.length > 0 ? userOptions : [];

  // Custom styles for select components
  const customStyles = {
    control: (base, state) => ({
      ...base,
      borderColor:
        errors.user || errors.contactType || errors.knowingType
          ? "#dc3545"
          : "#ced4da",
      "&:hover": {
        borderColor:
          errors.user || errors.contactType || errors.knowingType
            ? "#dc3545"
            : "#ced4da",
      },
      borderRadius: "7px",
      padding: "3px",
      minHeight: "40px",
      boxShadow: "none",
    }),
  };

  return (
    <div
      className="modal fade"
      id="addContactModal"
      tabIndex="-1"
      aria-labelledby="addContactModal"
      aria-hidden="true"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
    >
      <div className="modal-dialog modal-lg modal-dialog-centered">
        <div className="modal-content bg-white border-0 rounded-15">
          {/* ------ modal head section start ----- */}
          <div className="modal-header bg-primary text-white px-4 py-3 border-bottom border-gray-300">
            <div className="d-flex align-items-center gap-3">
              <div className="icon-wrapper p-3 bg-white rounded-circle d-flex align-items-center justify-content-center">
                <span className="material-symbols-outlined text-primary icon-md">
                  person_add
                </span>
              </div>
              <div>
                <h3
                  className="fw-bold fs-lg text-white mb-0"
                  id="addMemberLabel"
                >
                  {t("Invite / Add Contact")}
                </h3>
                <p className="text-white fs-sm mb-0">
                  {t("Configure your contact details")}
                </p>
              </div>
            </div>
            <button
              type="button"
              className="btn-close p-1 bg-gray-200 rounded-circle shadow-sm border-0"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={resetHandler}
            ></button>
          </div>
          {/* ------ modal head section end ----- */}
          {/* ------ modal body section start ----- */}
          <div className="modal-body p-4">
            <div className="p-3 p-md-4 border border-gray-300 rounded-10 shadow-sm">
              <form onSubmit={(e) => e.preventDefault()}>
                {/* ----- user select section start ----- */}
                <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                  <label
                    htmlFor="memberName"
                    className="d-block fs-sm fw-semibold mb-2 text-dark"
                  >
                    {t(
                      "Search for existing users or enter a new contact's email"
                    )}
                  </label>

                  <CreatableSelect
                    isClearable
                    styles={customStyles}
                    className="w-100"
                    placeholder={t("Enter name or email address")}
                    options={optionsToShow}
                    value={userValue}
                    onChange={(val) => {
                      userSelectionHandler(val);
                      if (errors.user) {
                        setErrors((prev) => ({ ...prev, user: "" }));
                      }
                      setErrorMessage("");
                    }}
                    onInputChange={(val) => {
                      userInputHandler(val);
                      if (errors.user) {
                        setErrors((prev) => ({ ...prev, user: "" }));
                      }
                      setErrorMessage("");
                    }}
                  />
                  {errors.user && (
                    <div className="invalid-feedback d-block">
                      {errors.user}
                    </div>
                  )}
                </div>
                {/* ----- user select section end ----- */}

                {/* <!-- ========== Start contact type Section ========== --> */}
                <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                  <label
                    htmlFor="memberName"
                    className="d-block fs-sm fw-semibold mb-2 text-dark"
                  >
                    {t("Relationship Type")}
                  </label>

                  <Select
                    isClearable
                    styles={customStyles}
                    className="w-100"
                    placeholder={t("Select Relationship Type")}
                    options={contactOptions}
                    value={selectContactOptionValue}
                    onChange={(val) => {
                      if (val) {
                        setSelectContactOptionValue(val);
                        setSelectContactOption(val.value);
                        if (errors.contactType) {
                          setErrors((prev) => ({ ...prev, contactType: "" }));
                        }
                        setErrorMessage("");
                      } else {
                        setSelectContactOptionValue(null);
                        setSelectContactOption("");
                      }
                    }}
                  />
                  {errors.contactType && (
                    <div className="invalid-feedback d-block">
                      {errors.contactType}
                    </div>
                  )}
                </div>
                {/* <!-- ========== End contact type Section ========== --> */}

                {/* <!-- ========== Start knowing type Section ========== --> */}
                <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                  <label
                    htmlFor="memberName"
                    className="d-block fs-sm fw-semibold mb-2 text-dark"
                  >
                    {t("How do you know this person?")}
                  </label>

                  <Select
                    isClearable
                    styles={customStyles}
                    className="w-100"
                    placeholder={t("Select how you know this person")}
                    options={knowingOptions}
                    value={selectKnowingOptionValue}
                    onChange={(val) => {
                      if (val) {
                        setselectKnowingOptionValue(val);
                        setselectKnowingOption(val.value);
                        if (errors.knowingType) {
                          setErrors((prev) => ({ ...prev, knowingType: "" }));
                        }
                        setErrorMessage("");
                      } else {
                        setselectKnowingOptionValue(null);
                        setselectKnowingOption("");
                      }
                    }}
                  />
                  {errors.knowingType && (
                    <div className="invalid-feedback d-block">
                      {errors.knowingType}
                    </div>
                  )}
                </div>
                {/* <!-- ========== End knowing type Section ========== --> */}

                {/* <!-- ========== Start message Section ========== --> */}
                <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                  <label
                    htmlFor="memberName"
                    className="d-block fs-sm fw-semibold mb-2 text-dark"
                  >
                    {t("Personalized Message")}
                  </label>
                  <textarea
                    className={`form-control fs-sm shadow-none ${
                      errors.connectMessage
                        ? "is-invalid"
                        : "border border-gray-300"
                    }`}
                    placeholder={t("Enter a personal message for the contact")}
                    rows={5}
                    value={connectMessage}
                    onChange={(e) => {
                      setConnectMessage(e.target.value);
                      if (errors.connectMessage) {
                        setErrors((prev) => ({ ...prev, connectMessage: "" }));
                      }
                      setErrorMessage("");
                    }}
                  ></textarea>
                  {errors.connectMessage && (
                    <div className="invalid-feedback">
                      {errors.connectMessage}
                    </div>
                  )}
                </div>
                {/* <!-- ========== End message Section ========== --> */}

                {/* <!-- ========== Start button and error message Section ========== --> */}
                <div className="action d-flex justify-content-end pt-3 border-top mt-4">
                  {errorMessage == "" ? null : (
                    <p className="text-danger fw-semibold me-3">
                      * {errorMessage}
                    </p>
                  )}
                  <button
                    type="button"
                    className="btn btn-primary d-flex align-items-center gap-2"
                    onClick={sendInviteHandler}
                    disabled={isAdding ? true : false}
                    style={{
                      cursor: isAdding ? "not-allowed" : "pointer",
                    }}
                  >
                    <span className="material-symbols-outlined me-1">send</span>{" "}
                    {t("Send Request")}
                    {isAdding && (
                      <div
                        className="mx-2 spinner-border spinner-border-sm"
                        role="status"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    )}
                  </button>
                </div>
                {/* <!-- ========== End button and error message Section ========== --> */}
              </form>
            </div>
          </div>
          {/* ------ modal body section end ----- */}
        </div>
      </div>
    </div>
  );
};

export default AddNewContactModal;
